import { mapDocumentToWriteDocument } from '#api/adapters/documentAdapter.ts';
import { useUploadStopDocumentMutation, useUploadTourDocumentMutation } from '#api/documentApi.slice.ts';
import { useUploadLinkMutation } from '#api/documentLinkApi.slice.ts';
import type { Document } from '#domain/Document.ts';

import type { UploadDocumentTarget } from '../model/UploadDocumentTarget.ts';
import { uploadFileToPresignedUrl } from '../service/uploadFileToPresignedUrl.ts';

export const useUploadDocument = (target: UploadDocumentTarget) => {
    const [getUploadLink] = useUploadLinkMutation(); // Step 1
    const [uploadStop] = useUploadStopDocumentMutation();
    const [uploadTour] = useUploadTourDocumentMutation();

    const upload = async ({ file, associations }: { file: File; associations: Document['associations'] }) => {
        // Step 1
        const id = crypto.randomUUID();
        const { data, error } = await getUploadLink({ documentId: id, fileName: file.name });
        if (error) {
            console.log('Upload link failed:', error);
            throw error;
        }
        const uploadUrl = data.url;
        console.log('Upload link fetched:', uploadUrl);

        // Step 2
        await uploadFileToPresignedUrl({
            file,
            uploadUrl,
            onProgress: percent => console.log(`Upload progress: ${percent}%`),
        });
        console.log('Upload successful');

        // Step 3
        const document = mapDocumentToWriteDocument({
            type: 'other', // TODO: add dropdown for type selection
            id,
            fileName: file.name,
            name: file.name,
            origin: 'dispatcher',
            externalId: '',
            associations,
        });
        if (target.stopId) {
            await uploadStop({ stopId: target.stopId, document }).unwrap();
        } else if (target.tourId) {
            await uploadTour({ tourId: target.tourId, document }).unwrap();
        } else {
            throw new Error('No stopId or tourId provided for document upload');
        }
        console.log('Uploaded metadata');
    };

    return { upload };
};
